module.exports = __webpack_public_path__ + "static/img/AllInOne1.14ed4b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AllInOne1.png
// module id = 4WOa
// module chunks = 2